import Http from '../api/http';

export default class Report extends Http {
  constructor() {
    super();
  }
  /**
   * @description: 获取任务详情
   * @param {type}
   * taskId
   * storeId
   * reportId
   * @return:
   */
  report_myTaskReportInfo() {
    return super.post('report/myTaskReportInfo', ...arguments);
  }
  /**
   * @description: 获取用户的任务列表
   * @param {type}
   * page
   * rows
   * type 2进行中 3已结束
   * @return:
   */
  report_myTaskList() {
    return super.post('report/myTaskList', ...arguments);
  }
  /**
   * @description: 获取用户的任务数量
   * @param {type}
   * @return:
   */
  report_myTaskAmount() {
    return super.post('report/myTaskAmount', ...arguments);
  }
  /**
   * @description: 获取用户的报告列表
   * @param {type}
   * @return:
   */
  report_getReportList2User() {
    return super.post('report/getReportList2User', ...arguments);
  }
  /**
   * @description: 修改预设暗访时间
   * @param {type} {
   *                cameDate,
   *                reportLogId
   *                }
   * @content-type JSON
   * @return:
   */
  report_modifyCameDateToC() {
    return super.post('report/modifyCameDateToC', ...arguments);
  }
  /**
   * @description: 获取我的任务记录
   * @param {type} reportLogId
   * @return:
   */
  report_myTaskLog() {
    return super.post('report/myTaskLog', ...arguments);
  }
  /**
   * @description: 用户放弃任务次数查询
   * @param {type} userId
   * @return:
   */
  report_abandonReportConut() {
    return super.post('report/abandonReportConut', ...arguments);
  }
  /**
   * @description: 用户主动放弃任务
   * @param {type} reportId
   * @return:
   */
  report_abandonTaskReport() {
    return super.post('report/abandonTaskReport', ...arguments);
  }
  /**
   * @description: 结账单、消费发票、支付记录md5值验证 20191018弃用
   * @param {type}
   * @return:
   */
  report_validPicture() {
    return super.post('report/validPicture', ...arguments);
  }
  //我的报告记录
  report_myPassedReportList() {
    return super.post('report/myPassedReportList', ...arguments);
  }

  //预放弃任务，检查放弃任务次数并提示
  report_preAbandonMyTask() {
    return super.post('report/preAbandonMyTask', ...arguments);
  }
  //预放弃任务
  report_abandonMyTask() {
    return super.post('report/abandonMyTask', ...arguments);
  }
  /**
   * 报告录音
   * @returns
   */
  report_getReportAllSoundFile() {
    return super.post('report/getReportAllSoundFile', ...arguments);
  }
  /**
   * 文件转换格式
   * @returns
   */
  file_fileTransferFormat() {
    return super.post('file/fileTransferFormat', ...arguments);
  }
  /**
   * 获取报告任务的任务信息
   * @returns
   */
  report_getReportTaskInfo() {
    return super.post('report/getReportTaskInfo', ...arguments);
  }
  /**
   * 获取报告体验的基础信息
   * @returns
   */
  report_getReportExperienceBaseInfo() {
    return super.post('report/getReportExperienceBaseInfo', ...arguments);
  }
  /**
   * 保存报告体验的基础信息
   * @returns
   */
  report_saveReportExperienceBaseInfo() {
    return super.post('report/saveReportExperienceBaseInfo', ...arguments);
  }
  /**
   * 提交报告
   * @returns
   */
  report_submitReport() {
    return super.post('report/submitReport', ...arguments);
  }
  /**
   * 获取线下报告信息
   * @returns
   */
  report_getOfflineReportInfo() {
    return super.post('report/getOfflineReportInfo', ...arguments);
  }
  /**
   * 保存线下报告url信息
   * @returns
   */
  report_saveOffLineReport() {
    return super.post('report/saveOffLineReport', ...arguments);
  }
  /**
   * 通过图片URL提取字段内容
   * @returns
   */
  report_extractFieldByImageUrl() {
    return super.post('report/extractFieldByImageUrl', ...arguments);
  }
}
